import {
  RECEIVE_EVENTS,
  TOGGLE_REPETITION,
  TOGGLE_ALL,
  RECEIVE_ACCOUNTS,
  RECEIVE_ACCOUNT,
  LOADING_ACCOUNTS,
  LOADING_ACCOUNT,
  LOADING_EVENTS,
  TOGGLE_SECTOR,
  TOGGLE_ALL_SECTORS,
  TOGGLE_BENEFIT,
  TOGGLE_ALL_BENEFITS_IN_ACCORDION,
  TOGGLE_ALL_BENEFITS,
  CLEAR_SECTORS,
  FINISH_RECEIVE_EVENTS,
  SYNC_STORAGE_EVENTS,
  VALIDATE_MENU_EVENTS,
  CLEAR_EVENTS,
} from './actions';
import { serializeUhuuEvents, checkStoredEvents, getPossibleEvents } from '../../helpers/uhuu';

const initialState = {
  list: [],
  account: null,
  accounts: [],
  isLoading: false,
  isReceiveEventsFinished: false,
};

/* eslint-disable no-use-before-define */
export default function events(state = initialState, action) {
  switch (action.type) {
    case LOADING_EVENTS:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_ACCOUNTS:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_ACCOUNT:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVE_EVENTS:
      return {
        ...state,
        isLoading: false,
        isReceiveEventsFinished: true,
        list: serializeUhuuEvents(action.events),
      };
    case RECEIVE_ACCOUNTS:
      return {
        ...state,
        isLoading: false,
        accounts: action.accounts,
      };
    case RECEIVE_ACCOUNT:
      return {
        ...state,
        isLoading: false,
        account: action.account,
      };
    case TOGGLE_REPETITION:
      return {
        ...state,
        list: toggleRepetition(state.list, action.exibithionId, action.repetitionId),
      };
    case TOGGLE_SECTOR:
      return {
        ...state,
        list: toggleSector(action.sectorId, action.repetitions, state.list),
      };
    case TOGGLE_ALL_SECTORS:
      return {
        ...state,
        list: toggleAllSectors(action.repetitions, state.list),
      };
    case TOGGLE_BENEFIT:
      return {
        ...state,
        list: toggleBenefit(action.sectorId, action.benefitId, state.list),
      };
    case TOGGLE_ALL_BENEFITS:
      return {
        ...state,
        list: toggleAllBenefits(action.repetitions, state.list),
      };
    case TOGGLE_ALL_BENEFITS_IN_ACCORDION:
      return {
        ...state,
        list: toggleAllBenefitsInAccordion(action.sectorId, state.list),
      };
    case TOGGLE_ALL:
      return {
        ...state,
        list: toggleAll(state.list, action.exibithionId),
      };
    case CLEAR_SECTORS:
      return {
        ...state,
        list: state.list.map(ev => ({
          ...ev,
          exhibitions: ev.exhibitions.map(exibithion => ({
            ...exibithion,
            repetitions: exibithion.repetitions.map(rep => ({
              ...rep,
              sectors: rep.sectors.map(sector => ({
                ...sector,
                checked: false,
                benefits: sector.benefits.map(benefit => ({
                  ...benefit,
                  checked: false,
                })),
              })),
            })),
          })),
        })),
      };
    case FINISH_RECEIVE_EVENTS:
      return {
        ...state,
        isReceiveEventsFinished: false,
      };
    case SYNC_STORAGE_EVENTS:
      return {
        ...state,
        list: checkStoredEvents(state.list, action.events),
      };
    case VALIDATE_MENU_EVENTS:
      return {
        ...state,
        list: getPossibleEvents({
          events: state.list,
          menus: action.menus,
          accId: action.accountId,
          saleType: action.saleType,
          menuId: action.idMenu,
        }),
      };
    case CLEAR_EVENTS:
      return { ...initialState };
    default:
      return state;
  }
}

function isAllUnchecked(eventList, exibithionId) {
  let isUnchecked = false;
  eventList.forEach(e => {
    e.exhibitions.forEach(ap => {
      if (ap.id === exibithionId) {
        isUnchecked = ap.repetitions.every(rep => !rep.checked);
      }
    });
  });
  return isUnchecked;
}

function isAllSectorsUnchecked(repetitions, eventList) {
  let isUnchecked = false;
  eventList.forEach(e => {
    e.exhibitions.forEach(ex => {
      ex.repetitions.forEach(rep => {
        if (repetitions.includes(rep.id)) {
          isUnchecked = rep.sectors.every(sec => !sec.checked);
        }
      });
    });
  });
  return isUnchecked;
}

function isAllBenefitsInAccordionUnchecked(sectorId, eventList) {
  let isUnchecked = false;
  eventList.forEach(e => {
    e.exhibitions.forEach(ex => {
      ex.repetitions.forEach(rep => {
        if (rep.checked) {
          rep.sectors.forEach(sec => {
            if (sec.id === sectorId) {
              isUnchecked = sec.benefits.every(ben => !ben.checked);
            }
          });
        }
      });
    });
  });
  return isUnchecked;
}

function isAllBenefitsUnchecked(repetitions, eventList) {
  const benefits = [];
  eventList.forEach(e => {
    e.exhibitions.forEach(ex => {
      ex.repetitions.forEach(rep => {
        if (repetitions.includes(rep.id)) {
          rep.sectors
            .filter(sec => sec.checked)
            .forEach(sec => {
              sec.benefits.forEach(benefit => {
                benefits.push(benefit);
              });
            });
        }
      });
    });
  });
  return benefits.every(ben => !ben.checked);
}

function toggleAll(eventList, exibithionId) {
  const allUnchecked = isAllUnchecked(eventList, exibithionId);
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions:
        ap.id === exibithionId
          ? ap.repetitions.map(rep => ({
              ...rep,
              checked: !rep.disabled ? allUnchecked : rep.checked,
            }))
          : ap.repetitions,
    })),
  }));
}

function toggleRepetition(eventList, exibithionId, repetitionId) {
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions:
        ap.id === exibithionId
          ? ap.repetitions.map(rep => {
              return {
                ...rep,
                checked: repetitionId === rep.id ? !rep.checked : rep.checked,
                sectors:
                  repetitionId === rep.id
                    ? updateRepSections(rep, ap)
                    : updateOtherRepSections(repetitionId, rep.sectors, ap),
              };
            })
          : ap.repetitions,
    })),
  }));
}

function toggleBenefit(sectorId, benefitId, eventList) {
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions: ap.repetitions.map(rep => ({
        ...rep,
        sectors: rep.sectors.map(sector => ({
          ...sector,
          benefits:
            sector.id === sectorId && sector.checked
              ? sector.benefits.map(benefit => ({
                  ...benefit,
                  checked: benefit.id === benefitId ? !benefit.checked : benefit.checked,
                }))
              : sector.benefits,
        })),
      })),
    })),
  }));
}

function toggleAllBenefitsInAccordion(sectorId, eventList) {
  const allUnchecked = isAllBenefitsInAccordionUnchecked(sectorId, eventList);
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions: ap.repetitions.map(rep => ({
        ...rep,
        sectors: rep.sectors.map(sector => ({
          ...sector,
          benefits:
            sector.id === sectorId && sector.checked
              ? sector.benefits.map(benefit => ({
                  ...benefit,
                  checked: !benefit.disabled ? allUnchecked : benefit.checked,
                }))
              : sector.benefits,
        })),
      })),
    })),
  }));
}

function toggleAllBenefits(repetitions, eventList) {
  const allUnchecked = isAllBenefitsUnchecked(repetitions, eventList);
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions: ap.repetitions.map(rep => ({
        ...rep,
        sectors: repetitions.some(repSelected => repSelected === rep.id)
          ? rep.sectors.map(sector => ({
              ...sector,
              benefits: sector.checked
                ? sector.benefits.map(benefit => {
                    return {
                      ...benefit,
                      checked: !benefit.disabled ? allUnchecked : benefit.checked,
                    };
                  })
                : sector.benefits,
            }))
          : rep.sectors,
      })),
    })),
  }));
}

function toggleSector(sectorId, repetitions, eventList) {
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions: ap.repetitions.map(rep => ({
        ...rep,
        sectors: repetitions.some(repSelected => repSelected === rep.id)
          ? rep.sectors.map(sector => {
              if (sector.id === sectorId) {
                return {
                  ...sector,
                  checked: sector.id === sectorId ? !sector.checked : sector.checked,
                  benefits: updateSecBenefits(sector, ap),
                };
              }
              return sector;
            })
          : rep.sectors,
      })),
    })),
  }));
}

function toggleAllSectors(repetitions, eventList) {
  const allUnchecked = isAllSectorsUnchecked(repetitions, eventList);
  return eventList.map(e => ({
    ...e,
    exhibitions: e.exhibitions.map(ap => ({
      ...ap,
      repetitions: ap.repetitions.map(rep => ({
        ...rep,
        sectors: repetitions.some(repSelected => repSelected === rep.id)
          ? rep.sectors.map(sector => {
              return {
                ...sector,
                checked: !sector.disabled ? allUnchecked : sector.checked,
                benefits: updateSecBenefits(sector, ap),
              };
            })
          : rep.sectors,
      })),
    })),
  }));
}

function updateSecBenefits(sector, exibithion) {
  const someBenefitDisabled = benefitId =>
    exibithion.repetitions.some(rep =>
      rep.sectors.some(
        sec =>
          sec.id === sector.id &&
          sector.benefits.some(ben => benefitId === ben.id && !!ben.disabled)
      )
    );
  return sector.checked
    ? sector.benefits.map(benefit => ({ ...benefit, checked: false }))
    : sector.benefits.map(benefit => ({
        ...benefit,
        checked:
          !(benefit.disabled || someBenefitDisabled(benefit.id)) &&
          sector.benefits.some(ben => ben.id === benefit.id && ben.checked),
        disabled: benefit.disabled || someBenefitDisabled(benefit.id),
      }));
}

function updateRepSections(rep, exibithion) {
  const someSectorDisabled = secId =>
    exibithion.repetitions.some(
      rep =>
        rep.checked && rep.sectors.some(sec => sec.id === secId && !!sec.disabled && !!sec.checked)
    );

  const someSectorChecked = secId =>
    exibithion.repetitions.some(
      rep => rep.checked && rep.sectors.some(sec => sec.id === secId && !!sec.checked)
    );

  const someBenefitDisabled = (benefitId, secId) =>
    exibithion.repetitions.some(rep =>
      rep.sectors.some(
        sec =>
          sec.id === secId &&
          sec.benefits.some(ben => benefitId === ben.id && !!ben.disabled && !!ben.checked)
      )
    );

  const someBenefitChecked = (benefitId, secId) =>
    exibithion.repetitions.some(rep =>
      rep.sectors.some(
        sec =>
          sec.id === secId &&
          sec.benefits.some(ben => benefitId === ben.id && !ben.disabled && !!ben.checked)
      )
    );

  return rep.checked
    ? rep.sectors.map(sec => ({
        ...sec,
        checked: false,
        benefits: sec.benefits.map(benefit => ({ ...benefit, checked: false })),
      }))
    : rep.sectors.map(sector => ({
        ...sector,
        checked:
          !(sector.disabled || someSectorDisabled(sector.id)) && someSectorChecked(sector.id),
        disabled: sector.disabled || someSectorDisabled(sector.id),
        benefits: sector.benefits.map(ben => {
          return {
            ...ben,
            checked:
              !(ben.disabled || someBenefitDisabled(ben.id, sector.id)) &&
              (ben.checked || someBenefitChecked(ben.id, sector.id)),
            disabled: ben.disabled || someBenefitDisabled(ben.id, sector.id),
          };
        }),
      }));
}

function updateOtherRepSections(repetitionId, sectors, exhibition) {
  const someBenefitDisabled = (sectorId, benefitId) =>
    exhibition.repetitions.some(
      repetition =>
        (!!repetition.checked || repetition.id === repetitionId) &&
        repetition.sectors.some(
          sector =>
            sector.id === sectorId &&
            sector.benefits.some(benefit => benefit.id === benefitId && !!benefit.disabled)
        )
    );

  const someSectorDisabled = sectorId =>
    exhibition.repetitions.some(
      repetition =>
        (!!repetition.checked || repetition.id === repetitionId) &&
        repetition.sectors.some(sector => sector.id === sectorId && !!sector.disabled)
    );

  return sectors.map(sector => ({
    ...sector,
    checked: !!sector.checked && !someSectorDisabled(sector.id),
    benefits: sector.benefits.map(benefit => ({
      ...benefit,
      checked: !!benefit.checked && !someBenefitDisabled(sector.id, benefit.id),
    })),
  }));
}



// WEBPACK FOOTER //
// ./src/store/events/reducer.js